import { useLayoutEffect, useRef, useState } from 'react'

import { TextClamp } from '../Base/TextFormat'
import { Button } from '../Button/Button'

interface ReadMoreProps {
  children: React.ReactNode
  lines?: number
}

export function ReadMore({ children, lines }: ReadMoreProps) {
  const ref = useRef<HTMLDivElement>(null)
  const [canExpand, setCanExpand] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  useLayoutEffect(() => {
    if (!ref.current) return
    // https://stackoverflow.com/questions/52169520/how-can-i-check-whether-line-clamp-is-enabled
    if (ref.current.clientHeight !== ref.current.scrollHeight) {
      setCanExpand(true)
    }
  }, [])

  if (isExpanded) return <>{children}</>

  return (
    <>
      <TextClamp ref={ref} lines={lines}>
        {children}
      </TextClamp>
      {canExpand && (
        <Button variant="text" margin="10px 0 0" onClick={() => setIsExpanded(true)}>
          Read more
        </Button>
      )}
    </>
  )
}
